import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export const store = new Vuex.Store({
    user: null,
    lists:null,

    state: {
        user: '',
        lists:''
    },
    mutations: {
        change(state, user) {
            state.user = user
        }
    },
    getters: {
        user: state => state.user,
        lists: state => state.lists
      }

})